module.exports = __webpack_public_path__ + "static/media/donate_icon.c381b203.svg";